import React, {useRef, useEffect, useState } from 'react';
import axios from 'axios';
import '../../App.css';
import './product.css'
import Seo from "../../Seo";
import { Link } from 'react-router-dom'; 
import Sidebar from '../../Sidebar';
  
function Products() {
    const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get('/backend/home.php', {
      headers: {
          'Custom-type': 'product',
          'Content-Type': 'application/json',  // Beispiel für Content-Type
          // Weitere Header können hier hinzugefügt werden
      }
  })
  .then(response => {
      setItems(response.data);
  })
  .catch(error => {
      console.error('Es gab einen Fehler beim Abrufen der Daten:', error);
  });
  }, []);

      useEffect(() => {
          LanguageChange();
        }, [items]);//
      
    const LanguageChange = () =>{
      const languageIndex = sessionStorage.getItem("language_index");
      const isEnglish = languageIndex != null && languageIndex == 1;
      setImageParameter(isEnglish ? "en" :  "");
      document.getElementById("Vulpio_undertopic").innerText= isEnglish ? "Learn something new every day" : "Lerne jeden Tag etwas Neues";
       document.getElementById("Vulpio_topic").innerText= isEnglish ? "Vulpio – Daily Knowledge Quiz" : "Vulpio – Tägliches Wissensquiz";
      document.getElementById("CosmicTap_undertopic").innerText= isEnglish ? "Destroy planets quickly!" : "Zerstöre Planeten schnell";
      document.getElementById("DontAsk_undertopic").innerText= isEnglish ? "Spicy & Fun Question Game" : "Das lustige Fragenspiel";
       document.getElementById("Drunkmaster_topic").innerText= isEnglish ? "DrunkMaster - The Party Game" : "DrunkMaster – Das Partyspiel";
      document.getElementById("Drunkmaster_undertopic").innerText= isEnglish ? "1600+ questions, 7 game modes" : "1600+ Fragen, 7 Spielmodi";

      document.getElementById("CosmicTap_txt").innerText= isEnglish ? "Tap planets away in just 5 seconds, collect points and extend your time. Use power-ups, defeat aliens, avoid black holes and conquer the leaderboard. Level up, improve upgrades and show how fast you really are!" : "Tippe Planeten in nur 5 Sekunden weg, sammle Punkte und verlängere deine Zeit. Nutze Power-Ups, besiege Aliens, meide Schwarze Löcher und erobere die Bestenliste. Level auf, verbessere Upgrades und zeig, wie schnell du wirklich bist!";
      document.getElementById("Vulpio_txt").innerText= isEnglish ? "Vulpio is a knowledge quiz app with thousands of questions across many topics. Learn something new every day, play in different modes, and get an explanation after every question. Customize your home screen with favorites and choose the challenge that fits you best." : "Vulpio ist ein Wissensquiz mit tausenden Fragen aus vielen Themenbereichen. Lerne jeden Tag etwas Neues, spiele in verschiedenen Modi und erhalte nach jeder Frage direkt eine Erklärung. Passe deine Startseite mit Favoriten an und stelle dich genau der Herausforderung, die zu dir passt.";
      document.getElementById("DontAsk_txt").innerText= isEnglish ? "Funny, profound and cheeky questions for friends, dates or parties. Over 230 free questions, 60+ exclusive spicy questions, no login required and 100% ad-free. Break the ice, discover new things and have lots of fun!" : "Lustige, tiefgründige und freche Fragen für Freunde, Dates oder Partys. Über 230 kostenlose Fragen, 60+ exklusive Spicy-Fragen, kein Login und 100% werbefrei. Brich das Eis, entdecke Neues und hab jede Menge Spaß!";
      document.getElementById("Drunkmaster_txt").innerText= isEnglish ? "7 game modes and 14 crazy events guarantee fun, action and unforgettable evenings. Play ‘Would You Rather?’, ‘Truth or Dare’, ‘I've Never’ and more – all mixed up in Shuffle mode. With unlimited players, automatic scoring and penalty counters, customisable settings and the option to add your own questions, every round is unique." : "7 Spielmodi und 14 verrückte Events sorgen für Spaß, Action und unvergessliche Abende. Spiele „Wer würde eher?“, „Wahrheit oder Pflicht“, „Ich hab noch nie“ und mehr – im Shuffle-Modus alles bunt gemischt. Mit unbegrenzten Mitspielenden, automatischem Punkte- & Strafzähler, individuellen Einstellungen und der Möglichkeit, eigene Fragen hinzuzufügen, bleibt jede Runde einzigartig.";
      document.getElementById("topic_header").innerText= isEnglish ? "Applications" : "Anwendungen";
      document.getElementById("text_header").innerText= isEnglish ? "Apps designed and developed by me" : "Von mir entworfene und entwickelte Apps";
      var previewitems =document.getElementsByClassName("preview");
      for(var item of previewitems){
        item.innerText= isEnglish ? "Preview" : "Vorschau";
      }
       var previewitems2 =document.getElementsByClassName("published");
      for(var item of previewitems2){
        item.innerText= isEnglish ? "Published" : "Veröffentlicht";
      }
       var previewitems3 =document.getElementsByClassName("programmed");
      for(var item of previewitems3){
        item.innerText= isEnglish ? "Programmed in" : "Programmiert in";
      }
    }
const [isMobile,setIsMobile] = useState("visible");
const [image_parameter,setImageParameter] = useState("");
  useEffect(() => {
   
    if(window.innerWidth <= 768){
      setIsMobile("hidden");
      document.getElementById("vulpiotext").style.visibility = "visible";
      document.getElementById("cosmictaptext").style.visibility = "visible";
      document.getElementById("dontasktext").style.visibility = "visible";
      document.getElementById("drunkmastertext").style.visibility = "visible";
    }



  }, []);

    const hideinfoText = (id) => {
    const el = document.getElementById(id);
  const style = window.getComputedStyle(el).visibility;

  if (style === "hidden") {
    el.style.visibility = "visible";
  } else {
    el.style.visibility = "hidden";
  }
    }
  const scrollCosmicTap = useRef(null);

  const CosmicTapscroll = (direction) => {
    var element=document.getElementById("CosmicTapSize");
  
    if(direction === "right"){
      document.getElementById("CosmicTapRight_button").style.visibility = "visible"; 
    
    }
    
    if(element.scrollLeft -element.offsetWidth  <=0 && direction != "right"){
       document.getElementById("CosmicTapRight_button").style.visibility = "hidden"; 
    }
    if (scrollCosmicTap.current) {
      scrollCosmicTap.current.scrollBy({
       
        left: direction === "left" ? -element.offsetWidth : element.offsetWidth, // 200px pro Klick
        behavior: "smooth",
      });
    }
  };

    const scrollVulpio = useRef(null);

  const Vulpioscroll = (direction) => {
    var element=document.getElementById("VulpioSize");
  
    if(direction === "right"){
      document.getElementById("VulpioRight_button").style.visibility = "visible"; 
    
    }
    
    if(element.scrollLeft -element.offsetWidth  <=0 && direction != "right"){
       document.getElementById("VulpioRight_button").style.visibility = "hidden"; 
    }
    if (scrollVulpio.current) {
      scrollVulpio.current.scrollBy({
       
        left: direction === "left" ? -element.offsetWidth : element.offsetWidth, // 200px pro Klick
        behavior: "smooth",
      });
    }
  };

  const scrollDontAsk = useRef(null);

  const DontAskscroll = (direction) => {
    var element=document.getElementById("DontAskSize");
  
    if(direction === "right"){
      document.getElementById("DontAskLeft_button").style.visibility = "visible"; 
    
    }
    
    if(element.scrollLeft -element.offsetWidth  <=0 && direction != "right"){
       document.getElementById("DontAskLeft_button").style.visibility = "hidden"; 
    }
    if (scrollDontAsk.current) {
      scrollDontAsk.current.scrollBy({
       
        left: direction === "left" ? -element.offsetWidth : element.offsetWidth, // 200px pro Klick
        behavior: "smooth",
      });
    }
  };

    const scrollDrunkmaster = useRef(null);

  const Drunkmasterscroll = (direction) => {
    var element=document.getElementById("DrunkmasterSize");
  
    if(direction === "right"){
      document.getElementById("DrunkmasterLeft_button").style.visibility = "visible"; 
    
    }
    
    if(element.scrollLeft -element.offsetWidth  <=0 && direction != "right"){
       document.getElementById("DrunkmasterLeft_button").style.visibility = "hidden"; 
    }
    if (scrollDrunkmaster.current) {
      scrollDrunkmaster.current.scrollBy({
       
        left: direction === "left" ? -element.offsetWidth : element.offsetWidth, // 200px pro Klick
        behavior: "smooth",
      });
    }
  };



  return (
    <>
        <Seo
  title="Apps & Projekte – Finn Mikoschek"
  description="Übersicht meiner Apps und Spiele: DrunkMaster, Vulpio, Don’t Ask und CosmicTap. Mobile Anwendungen für iOS und Android – entwickelt von Finn Mikoschek."
/>
    <div><Sidebar onLanguageChange={LanguageChange}/> 
    <div class="App-header">
      <div class="img_header"><h1 id='topic_header'>Apps</h1><p id='text_header'></p><img src="/images/header_1.webp"></img></div>
        <div class="text_container">
          <div class="text_container_data">
                        <div class="product_field">
              <div class="product_infofield">
                <img src="/images/vulpioicon.webp" id="product_icon"></img>
                <div class="product_overview">
                  <div className='overviewtopic'> <h1 id="Vulpio_topic"></h1><img src="/images/info-button.webp"  style={{ visibility:isMobile}} id="info_icon" onClick={() => hideinfoText("vulpiotext")}></img></div>
                    <a id="Vulpio_undertopic"></a>
                    <div class="downloadlinks">               
                      <a href="https://apps.apple.com/us/app/vulpio-daily-knowledge-quiz/id6749925988" target="_blank" rel="noopener noreferrer">
                        <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="Download on the App Store" id="downloadref"/>
                      </a>
                      <a href="https://play.google.com/store/apps/details?id=com.FinnMikoschek.everydaysomethingnew" target="_blank" rel="noopener noreferrer">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" id="downloadref"/>
                      </a>
                    </div>
                </div>
                <div className="appinfo" id="vulpiotext" >
                   <div className="row"><div className='row_line'><h4 className="published"></h4> <a>02.2026</a></div> <div className='row_line'> <h4 className="programmed"></h4><a>Flutter</a></div>  </div> 
                    <div className='appinfotext'>
                      <a id="Vulpio_txt"></a>
                    </div>
                  
                 
                </div>
            </div>
            <h2 className="preview"></h2>
            <div className="product_picturesframe">
                 <button className="round_button" onClick={() => Vulpioscroll("left")} id="VulpioRight_button"> <img src="/images/arrow02.webp"/></button>
                <div className="product_pictures" ref={scrollVulpio}  id='VulpioSize'>
                
                            <img src={`/images/vulpio01${image_parameter}.webp`} />
                   <img src={`/images/vulpio02${image_parameter}.webp`} />
                    <img src={`/images/vulpio03${image_parameter}.webp`} />
                  <img src={`/images/vulpio04${image_parameter}.webp`} />
                   <img src={`/images/vulpio05${image_parameter}.webp`} />
                    <img src={`/images/vulpio06${image_parameter}.webp`} />
                  
                </div>
                <button className="round_button" id="rightround_button" style={{ visibility:isMobile}}  onClick={() => Vulpioscroll("right")}><img src="/images/arrow.webp"/></button>
              </div>
              
            </div>
            <div class="product_field">
              <div class="product_infofield">
                <img src="/images/cosmictapicon.webp" id="product_icon"></img>
                <div class="product_overview">
                  <div className='overviewtopic'> <h1>CosmicTap</h1><img src="/images/info-button.webp"  style={{ visibility:isMobile}} id="info_icon" onClick={() => hideinfoText("cosmictaptext")}></img></div>
                    <a id="CosmicTap_undertopic"></a>
                    <div class="downloadlinks">               
                      <a href="https://apps.apple.com/de/app/cosmictap/id6740142053" target="_blank" rel="noopener noreferrer">
                        <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="Download on the App Store" id="downloadref"/>
                      </a>
                      <a href="https://play.google.com/store/apps/details?id=com.MikoschekSoftware.TapTheDot" target="_blank" rel="noopener noreferrer">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" id="downloadref"/>
                      </a>
                    </div>
                </div>
                <div className="appinfo" id="cosmictaptext" >
                   <div className="row"><div className='row_line'><h4 className="published"></h4> <a>03.2025</a></div> <div className='row_line'> <h4 className="programmed"></h4><a>C#/Unity</a></div>  </div> 
                    <div className='appinfotext'>
                      <a id="CosmicTap_txt"></a>
                    </div>
                  
                 
                </div>
            </div>
            <h2 className="preview"></h2>
            <div className="product_picturesframe">
                 <button className="round_button" onClick={() => CosmicTapscroll("left")} id="CosmicTapRight_button"> <img src="/images/arrow02.webp"/></button>
                <div className="product_pictures" ref={scrollCosmicTap}  id='CosmicTapSize'>
                
                  <img src="/images/cosmictap03.webp"/>
                  <img src="/images/cosmictap01.webp"/>
                  <img src="/images/cosmictap02.webp"/>
                  <img src={`/images/cosmictap05${image_parameter}.webp`} />
                   <img src={`/images/cosmictap06${image_parameter}.webp`} />
                    <img src={`/images/cosmictap07${image_parameter}.webp`} />
                  
                </div>
                <button className="round_button" id="rightround_button" style={{ visibility:isMobile}}  onClick={() => CosmicTapscroll("right")}><img src="/images/arrow.webp"/></button>
              </div>
              
            </div>

                        <div class="product_field">
              <div class="product_infofield">
                <img src="/images/dontaskicon.webp" id="product_icon"></img>
                <div class="product_overview">
                  <div className='overviewtopic'> <h1>Don’t Ask</h1><img src="/images/info-button.webp" style={{ visibility:isMobile}}  id="info_icon" onClick={() => hideinfoText("dontasktext")}></img></div>
                    <a id="DontAsk_undertopic"></a>
                    <div class="downloadlinks">               
                      <a href="https://apps.apple.com/de/app/cosmictap/id6740142053" target="_blank" >
                        <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="Download on the App Store" id="downloadref"/>
                      </a>
                      <a href="https://play.google.com/store/apps/details?id=com.MikoschekSoftware.TapTheDot" target="_blank" >
                        <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" id="downloadref"/>
                      </a>
                    </div>
                </div>
                                <div class="appinfo" id="dontasktext">
                   <div className="row"><div className='row_line'><h4 className="published"></h4> <a>07.2025</a></div> <div className='row_line'> <h4 className="programmed"></h4><a>Dart/Flutter</a></div>  </div> 
                    <div className='appinfotext'>
                      
<a id="DontAsk_txt"></a>
                 
                    </div>
                  
                 
                </div>

            </div>
            
             <h2 className="preview"></h2>
            <div className="product_picturesframe">
                 <button className="round_button" onClick={() => DontAskscroll("left")}   id="DontAskLeft_button" > <img src="/images/arrow02.webp" /></button>
                <div className="product_pictures" ref={scrollDontAsk}  id='DontAskSize'>
                
              <img src={`/images/dontask01${image_parameter}.webp`} />
    <img src={`/images/dontask02${image_parameter}.webp`} />
    <img src={`/images/dontask03${image_parameter}.webp`} />

                </div>
                
              </div>
            </div>

            <div class="product_field">
              <div class="product_infofield">
                <img src="/images/drunkmastericon.webp" id="product_icon"></img>
                <div class="product_overview">
                    <div className='overviewtopic'> <h1 id="Drunkmaster_topic"></h1><img src="/images/info-button.webp" style={{ visibility:isMobile}}  id="info_icon" onClick={() => hideinfoText("drunkmastertext")}></img></div>
                    
                    <a id="Drunkmaster_undertopic"></a>
                    <div class="downloadlinks">               
                      <a href="https://apps.apple.com/de/app/drunkmaster-das-partyspiel/id1539236513" target="_blank" >
                        <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="Download on the App Store" id="downloadref"/>
                      </a>
                      <a href="https://play.google.com/store/apps/details?id=com.MikoschekSoftware.Drunkmaster" target="_blank" >
                        <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" id="downloadref"/>
                      </a>
                    </div>
                </div>
                                                <div class="appinfo" id="drunkmastertext">
                   <div className="row"><div className='row_line'><h4 className="published" ></h4> <a>12.2019</a></div> <div className='row_line'> <h4 className="programmed"></h4><a>C#/Unity</a></div>  </div> 
                    <div className='appinfotext'>
                      <a id="Drunkmaster_txt"></a>
                 
                    </div>
                  
                 
                </div>

            </div>
            <h2 className="preview"></h2>
            <div className="product_picturesframe">
                 <button className="round_button" onClick={() => Drunkmasterscroll("left")}   id="DrunkmasterLeft_button"> <img src="/images/arrow02.webp"/></button>
                <div className="product_pictures" ref={scrollDrunkmaster}  id='DrunkmasterSize'>
                
                    <img src={`/images/drunkmaster01${image_parameter}.webp`} />
                     <img src={`/images/drunkmaster02${image_parameter}.webp`} />
                      <img src={`/images/drunkmaster03${image_parameter}.webp`} />
                       <img src={`/images/drunkmaster04${image_parameter}.webp`} />
                        <img src={`/images/drunkmaster05${image_parameter}.webp`} />
                         <img src={`/images/drunkmaster06${image_parameter}.webp`} />
                          <img src={`/images/drunkmaster07${image_parameter}.webp`} />
                          

                </div>
                <button className="round_button" id="rightround_button" style={{ visibility:isMobile}}  onClick={() => Drunkmasterscroll("right")}><img src="/images/arrow.webp"/></button>
              </div>
            </div>

        </div>
      </div>
    </div>
    </div>
    </>
  );
}

export default Products;